export default "__VITE_ASSET__D_M278bc__"